import { render, staticRenderFns } from "./ConsultarReserva.vue?vue&type=template&id=1f7852ca&"
import script from "./ConsultarReserva.vue?vue&type=script&lang=js&"
export * from "./ConsultarReserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports